import { render } from "./IconClock.vue?vue&type=template&id=747e7b6f"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconClock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "747e7b6f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('747e7b6f', __exports__)) {
    api.reload('747e7b6f', __exports__)
  }
  
  module.hot.accept("./IconClock.vue?vue&type=template&id=747e7b6f", () => {
    api.rerender('747e7b6f', render)
  })

}


export default __exports__